// 导出配置的路由器
export default [{
  path: '/login',
  component: () => import('@/module/login/page/login.vue'),
  name: '登录页面',
  hidden: true
}]



// WEBPACK FOOTER //
// ./src/module/login/router/index.js